angular.module('magpieFileUpload', [
  'ui.bootstrap'
]).
controller('MagpieFileUploadCtrl', function($scope, $http, baseUrlSrv) {
  const envelope = JSON.parse($scope.fileMetadata);
  $scope.metadata = envelope.fileMetadata;

  $scope.selectedFile = null;
  $scope.uploading = false;
  $scope.uploaded = false;
  $scope.error = null;

  $scope.onFileSelected = function(element) {
    $scope.$apply(function() {
      $scope.selectedFile = element.files[0] || null;
      $scope.error = null;
    });
  };

  $scope.upload = function() {
    if (!$scope.selectedFile) {
      return;
    }

    $scope.uploading = true;
    $scope.error = null;

    const reader = new FileReader();
    reader.onload = function() {
      const base64Content = btoa(
        new Uint8Array(reader.result)
          .reduce(function(data, byte) {
            return data + String.fromCharCode(byte);
          }, '')
      );

      const uploadPath = '/magpie/files/' + $scope.metadata.id;
      $http.post(baseUrlSrv.getRestApiBase() + uploadPath, {
        details: {
          name: $scope.metadata.name,
          extension: $scope.metadata.extension,
          description: $scope.metadata.description || null,
          mimeType: $scope.metadata.mimeType || null,
          installedFileName: $scope.metadata.installedFileName || $scope.selectedFile.name
        },
        base64Content: base64Content
      }).then(function() {
        $scope.uploading = false;
        $scope.uploaded = true;
      }).catch(function(response) {
        $scope.uploading = false;
        $scope.error = _.get(response, 'data.message', 'Upload failed. Please try again.');
      });
    };
    reader.onerror = function() {
      $scope.$apply(function() {
        $scope.uploading = false;
        $scope.error = 'Failed to read the selected file.';
      });
    };
    reader.readAsArrayBuffer($scope.selectedFile);
  };
}).
directive('magpieFileUpload', function() {
  return {
    restrict: 'E',
    scope: {
      fileMetadata: '@'
    },
    templateUrl: 'components/magpie-display/file-upload/file-upload.html',
    controller: 'MagpieFileUploadCtrl'
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/file-upload/magpie-file-upload.js